import {Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";
import {IProduct, IProductGroup} from "../product-models";
import * as _ from "lodash";
import {Constants} from "../../constants";
import {IShareLinkOptions} from "../../social/social-models";
import {take} from "rxjs/operators";
import {UsanaCurrencyPipe} from "../../currency/usana-currency.pipe";
import {forkJoin} from "rxjs";
import {ProductUtil} from "../../util/product-util";

@Component({
    selector: 'product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss', '../product.scss'],
    standalone: false
})
export class ProductCardComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() product: IProduct;
    @Input() productGroup: IProductGroup;
    @Input() cardClass: string;
    @Input() primaryActionsTemplate: TemplateRef<any>;
    @Input() secondaryActionsTemplate: TemplateRef<any>;
    @Input() hidePreferredPricing = false;
    @Input() hideStrikeThroughPricing = false;
    @Input() shareOptions: IShareLinkOptions;
    productVolume: string;
    priceDisplay: string;

    ProductUtil = ProductUtil;

    constructor(private userService: UserService, loggerService: LoggerService, private currencyPipe: UsanaCurrencyPipe) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.setupProduct();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.setupProduct();
    }

    setupShareOptions() {
        if (this.shareOptions) {
            this.shareOptions.shareId = this.product.usanaId;
            this.shareOptions.shareType = Constants.SHARE_TYPE_SHARE_ONE;
        }
    }

    setupProduct(): void {
        if (this.productGroup) {
            this.setUpProductFromProductGroup();
        } else {
            this.productVolume = this.product.price.volume.toString();
            this.currencyPipe.transform(this.product.price.price)
                .pipe(take(1))
                .subscribe((formattedPrice: string) => {
                    this.priceDisplay = formattedPrice;
                });
        }
        this.setupShareOptions();
    }

    setUpProductFromProductGroup() {
        this.product = _.cloneDeep(this.productGroup.products[this.productGroup.firstProductId]);
        this.product.productDescription = this.productGroup.productDescription;
        // use the images provided by the productGroup instead of those on the 0th product
        this.product.productImages = this.productGroup.catalogImages;
        this.setupProductGroupVolumes();
        this.setProductGroupPriceDisplay();
    }

    setupProductGroupVolumes() {
        if (this.productGroup.volumeMax !== this.productGroup.volumeMin) {
            this.productVolume = this.productGroup.volumeMin + ' - ' + this.productGroup.volumeMax;
        } else {
            this.productVolume = this.product.price.volume.toString();
        }
    }

    setProductGroupPriceDisplay() {
        if (this.productGroup.priceMin.price === this.productGroup.priceMax.price) {
            this.currencyPipe.transform(this.productGroup.priceMin.price)
                .pipe(take(1))
                .subscribe((formattedPrice: string) => {
                    this.priceDisplay = formattedPrice;
                });
        } else {
            const observables = [this.currencyPipe.transform(this.productGroup.priceMin.price), this.currencyPipe.transform(this.productGroup.priceMax.price)];
            forkJoin(observables).subscribe(([formattedMinPrice, formattedMaxPrice]: any) => {
                this.priceDisplay = formattedMinPrice + ' - ' + formattedMaxPrice;
            });
        }
    }

}
